import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface DemolitionLandProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const DemolitionLand: React.FC<DemolitionLandProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [demolition, set_demolition] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Demolition'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Demolition': v } } })
    );
    const label = 'Demolition';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(demolition)}
                />
            ) : (
                <MoneyBox
                    id={'demolition'}
                    allowNegative={false}
                    value={demolition ?? 0}
                    onChange={(value) => set_demolition(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
